<script setup lang="ts">
import { ref } from 'vue';

const resultsDummyValue = ref(1.0);

const keywordsDummyData = [
  { id: 1079, keyword: 'smältning' },
  { id: 1070, keyword: 'flytande form' },
  { id: 1106, keyword: 'kondensering' },
  { id: 1085, keyword: 'aggregationstillstånd' },
  { id: 1123, keyword: 'desublimering' },
  { id: 1075, keyword: 'fast form' },
  { id: 1091, keyword: 'kokning' },
  { id: 1112, keyword: 'förångning' },
  { id: 1114, keyword: 'sublimering' },
  { id: 940, keyword: 'Departement' },
  { id: 939, keyword: 'motion' },
  { id: 1100, keyword: 'gasform' },
  { id: 937, keyword: 'demokrati' },
];
const descriptionsDummyData = [
  { id: 1075, description: 'ett av de tre aggregationstillstånden hos ett ämne' },
  { id: 1123, description: 'när ett ämne går direkt från gasform till fast form' },
  { id: 1100, description: 'ett aggregationstillstånd där ett ämne passerat kokpunkten' },
  { id: 940, description: 'är i Sverige olika avdelningar som lyder under regeringen' },
  { id: 1070, description: 'ett aggregationstillstånd där ämnet är i form av vätska' },
  { id: 1106, description: 'en fasövergång när gas övergår till vätska' },
  { id: 1091, description: 'upphettning av vätska till dess kokpunkt' },
  { id: 1085, description: 'de olika former som ett ämne kan befinna sig i beroende på temperatur och tryck.' },
  { id: 939, description: 'ett förslag av en eller flera riksdagsledamöter' },
  { id: 1114, description: 'när ett ämne går direkt från fast form till gasform utan att smälta först' },
  { id: 1079, description: 'materias fasövergång från fast fas till vätska' },
  { id: 937, description: 'folkstyre' },
  { id: 1112, description: 'en fasövergång när en vätska eller fast ämne övergår till gasform' },
];

const answerFeedback = {
  0: ['All Correct 1', 'All Correct 2', 'All Correct 3'],
  1: ['Almost Correct 1', 'Almost Correct 2', 'Almost Correct 3'],
  2: ['Wrong 1', 'Wrong 2', 'Wrong 3'],
};

const randomFeedback = (key: keyof typeof answerFeedback) => Math.floor(Math.random() * answerFeedback[key].length);

const resultsFeedback = (result: number) => {
  if (result === 1.0) {
    return answerFeedback[0][randomFeedback(0)];
  }

  if (result > 1.0 && result < 1.5) {
    return answerFeedback[1][randomFeedback(1)];
  }
  return answerFeedback[2][randomFeedback(2)];
};

const showKeywordDescriptions = ref(false);

const combineKeywordDescriptions = () =>
  keywordsDummyData.map((keyword) => {
    const descriptionData = descriptionsDummyData.filter((description) => description.id === keyword.id).shift();
    return { ...keyword, description: descriptionData?.description };
  });
</script>

<template>
  <div class="result-feedback-container">
    <h2 class="result-feedback-title">Vad hände, hur gick det?</h2>
    <p class="result-feedback-text">{{ resultsFeedback(resultsDummyValue) }}</p>

    <div class="result-feedback-actions">
      <v-btn class="see-keywords-and-descriptions-button" @click="showKeywordDescriptions = !showKeywordDescriptions"
        >See the keywords + descriptions</v-btn
      >
      <v-btn class="play-again-button">Play again</v-btn>
    </div>

    <div v-if="showKeywordDescriptions">
      <div v-for="(keywordDescriptionPair, index) in combineKeywordDescriptions()" :key="index">
        <p>
          <b>{{ keywordDescriptionPair.keyword }}:</b>
          {{ keywordDescriptionPair.description }}
        </p>
      </div>
    </div>
  </div>
</template>
